import React from 'react'
import {
    Activity,
    AtSign,
    Compass,
    Mail,
    MessageCircle,
    Store,
    UserRound,
    Users,
} from 'lucide-react'
import Tabs from './Tabs'
import { scopedContentTabs } from './contentTabs'

export default function ScopedContentTabs({ surface, activeTab, onTabChange }) {
    const tabs = scopedContentTabs(surface).map(tab => ({
        ...tab,
        icon: {
            discover: Compass,
            items: Store,
            activity: Activity,
            mine: UserRound,
            following: Users,
            all: MessageCircle,
            threads: MessageCircle,
            mentions: AtSign,
            messages: Mail,
        }[tab.key],
        onSelect: () =>
            window.logEv(`CLICK_${surface.toUpperCase()}_${tab.key.toUpperCase()}_TAB`, {
                previous_tab: activeTab,
                from_location: 'stream_tabs',
            }),
    }))

    return (
        <Tabs
            activeTab={activeTab}
            onTabChange={onTabChange}
            tabs={tabs}
            ariaLabel="Channel tabs"
        />
    )
}
